<template>
  <div class="p-repost">
    <CommonHeader>
      {{ $t('release.repost_to_feed') }}
      <template slot="left">
        <a v-if="step === 1" @click.prevent="cancel">取消</a>
        <svg
          v-else
          class="m-style-svg m-svg-def"
          @click="preStep"
        >
          <use xlink:href="#icon-back" />
        </svg>
      </template>
      <template slot="right">
        <a
          v-if="step !== 2"
          :class="{ disabled }"
          class="m-send-btn"
          @click.prevent="nextStep"
        >下一步</a>
        <span
          v-if="step === 2"
          class="m-send-btn"
          @click="beforePost"
        >{{ $t('release.name') }}</span>
      </template>
    </CommonHeader>

    <TransitionGroup
      :enter-active-class="animated.enterClass"
      :leave-active-class="animated.leaveClass"
      tag="main"
      class="m-box-model m-flex-grow1 m-flex-shrink1 p-repost-main"
    >
      <div v-show="step === 1" key="step1">
        <div class="content-wrap">
          <textarea
            ref="textarea"
            v-model.trim="contentText"
            :rows="2"
            placeholder="说说分享心得..."
            maxlength="255"
            @blur="moveCurPos"
            @input="moveCurPos"
          />
          <!-- <TextareaInput
            v-model="contentText"
            placeholder="输入转发心得..."
            :maxlength="255"
            :warnlength="200"
            :rows="2"
          /> -->
          <Component
            :is="componentMap[repostType]"
            :id="repostId"
          />
        </div>
      </div>
      <div
        v-show="step === 2"
        key="step2"
        class="m-pos-f m-box-model m-flex-grow1 next-main"
      >
        <FormTagsBreakLine
          v-model="tags"
          class="select-tags"
          :label="$t('tags.select')"
          :placeholder="$t('tags.select')"
        />
        <div class="m-box-model m-attach">
          <div class="m-box m-justify-bet">
            <span class="m-attach-label">{{ $t('release.upload_attachment') }}</span>
            <input
              v-if="inputShow"
              ref="imagefile"
              type="file"
              class="m-rfile"
              @change="onBannerChange"
            >
            <div class="m-flex-grow1 m-flex-shrink1 m-text-r" @click="uploadAttachments">
              <button class="m-attach-btn">{{ $t('release.upload_attachment') }}</button>
              <!-- <div class="m-box m-justify-end"></div> -->
            </div>
          </div>
          <!-- attach list start -->
          <div
            v-for="attachment in attachments"
            :key="attachment.id"
            class="m-attach-files"
          >
            <div class="m-attach__file m-box" @click="$download(attachment, 'show')">
              <attachment-type :name="attachment.file.name" />
              <span class="m-attach__filename">{{ attachment.file.name }}</span>
              <img src="@/images/delete.png" @click.stop="deleteAttachments(attachment)">
            </div>
          </div>
          <!-- attach list end -->
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
  import _ from 'lodash'
  import sendImage from '@/util/SendImage.js'
  import AttachmentType from '@/components/common/AttachmentType.vue'
  import TextareaInput from '@/components/common/TextareaInput.vue'
  import ReferenceFeed from '@/components/reference/ReferenceFeed.vue'
  import ReferencePost from '@/components/reference/ReferencePost.vue'
  import ReferenceGroup from '@/components/reference/ReferenceGroup.vue'
  import ReferenceQuestion from '@/components/reference/ReferenceQuestion.vue'
  // import ReferenceAnswer from '@/components/reference/ReferenceAnswer.vue'
  const componentMap = {
    'feeds': ReferenceFeed,
    'groups': ReferenceGroup,
    'group-posts': ReferencePost,
    'questions': ReferenceQuestion,
    // 'question-answers': ReferenceAnswer,
  }
  const defaultTxtMap = {
    'feeds': '转发了分享',
    'groups': '转发了圈子',
    'group-posts': '转发了帖子',
    'questions': '转发了问题',
  // 'question-answers': '转发了回答',
  }
  export default {
    name: 'Repost',
    components: {
      AttachmentType,
      TextareaInput,
      ReferenceFeed,
      ReferencePost,
      ReferenceGroup,
      ReferenceQuestion,
    // ReferenceAnswer,
    },
    data () {
      return {
        step: 1,
        curpos: 0,
        pinned: false,
        loading: false,
        animated: {},
        contentText: '',
        tags: [],
        attachments: [],
        componentMap,
        defaultTxtMap,
        inputShow: true,
        showReward: false,
      }
    },
    computed: {
      disabled () {
        return !this.repostType || !this.repostId
      },
      repostId () {
        return parseInt(this.$route.query.repost_id)
      },
      repostType () {
        return this.$route.query.repost_type
      },
    },
    watch: {
      step (val) {
        val === 2 &&
          this.$nextTick(() => {
            if (this.$refs.editor) {
              this.$refs.editor.innerHTML = this.contentText
            }
          })
      },
    },
    mounted () {
      if (!this.repostId || !this.repostType) {
        this.$Message.error('转发参数错误')
        return this.goBack()
      }
    },
    methods: {
      preStep () {
        if (this.step <= 1) return
        this.animated = {
          enterClass: 'animated slideInLeft',
          leaveClass: 'animated slideOutRight',
        }
        this.step -= 1
      },
      nextStep () {
        if (this.disabled) return
        if (this.step < 2) {
          this.animated = {
            enterClass: 'animated slideInRight',
            leaveClass: 'animated slideOutLeft',
          }
          this.step += 1
        }
      },
      beforePost () {
        if (this.loading) return
        this.loading = true
        const body = this.contentText.replace(/(@\S*)\s/g, '\u00ad$1\u00ad ')
        this.$http
          .post(
            'feeds',
            {
              feed_from: 2,
              tags: this.tags,
              feed_mark: new Date().valueOf() + '' + this.$store.state.CURRENTUSER.id,
              repostable_id: this.repostId,
              repostable_type: this.repostType,
              feed_content: body || this.defaultTxtMap[this.repostType],
              attachments: this.attachments.map(item => item.id),
            },
            { validateStatus: s => s === 201 }
          )
          .then(() => {
            this.$Message.success(this.$t('release.success'))
            if (this.fromTopic) return this.goBack()
            setTimeout(() => {
              this.$router.replace('/shares')
            }, 300)
          })
          .finally(() => {
            this.loading = false
          })
      },
      cancel () {
        if (this.contentText.length === 0) return this.goBack()
        const actions = [
          {
            text: this.$t('confirm'),
            method: () => void this.goBack(),
          },
        ]
        this.$bus.$emit('actionSheet', actions, this.$t('cancel'), this.$t('release.confirm_cancel'))
      },
      uploadAttachments () {
        if (!this.inputShow) {
          return this.$Message.error('上传中...')
        }
        this.$refs.imagefile.click()
      },
      async onBannerChange () {
        this.inputShow = false
        const file = this.$refs.imagefile.files[0]
        const id = await sendImage(file)
        this.inputShow = true
        this.attachments.push({ id, file })
      },
      deleteAttachments ({ id }) {
        this.attachments = this.attachments.filter(item => item.id !== id)
      },
      moveCurPos (event) {
        this.$refs.textarea && (this.curpos = this.$refs.textarea.selectionStart)
        if (event.data === '@') {
          this.$bus.$emit('at', {
            callback: (username) => {
              const regex = RegExp(`(.{${this.curpos}})`)
              this.contentText = this.contentText.replace(regex, `$1${username} `)
              this.$nextTick(() => {
                this.$refs.textarea && this.$refs.textarea.focus()
              })
            },
          })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.p-repost-main {
  display: flex;
  flex-direction: column;
  background-color: @body-bg;
  min-height: 90vh;
  > div {
    animation-duration: 0.3s;
  }
  .m-pos-f {
    // top: 90px;
    position: relative;
    margin: 0;
  }
  .content-wrap {
    position: relative;
    width: 100%;
    height: calc(~'100% + 40px');
    margin-top: 30px;
    padding: 0 30px;
    textarea {
      width: 100%;
      min-height: 200px;
      word-wrap: break-word;
      word-break: break-all;
      font-size: inherit;
      text-align: inherit;
      line-height: inherit;
    }
  }
  .next-main {
    background-color: #f7f7f7;
    .select-tags {
      margin-top: 30px;
    }
  }
  .m-attach {
    margin-top: 30px;
    padding: 26px 20px;
    background-color: white;
    border-bottom: 1px solid @border-color;
    &-label {
      flex: none;
      align-self: flex-start;
      width: 150px;
    }
    &-btn {
      height: 50px;
      color: #fff;
      font-size: 24px;
      background-color: #00aeef;
      border-radius: 25px;
      padding: 8px 30px;
    }
    &-files {
      width: 100%;
    }
    &__file {
      flex-basis: 100%;
      margin-top: 20px;
      img {
        margin-left: 20px;
        width: 32px;
        height: 32px;
      }
    }
    &__filename {
      display: inline-block;
      font-size: 28px;
      margin-left: 20px;
      flex-grow: 1;
      word-break: break-all;
    }
  }
}
.m-attach-label {
  font-size: 30px;
}
</style>
